import * as TYPES from './types';

export const plansLoaded = (plan) => ({
  type: TYPES.FOLLOWUP_PLAN_LOAD_SUCCESS,
  state: {
    followUpPlan: plan,
  },
});

export const plansLoadFailed = (message) => ({
  type: TYPES.FOLLOWUP_PLAN_LOAD_FAILURE,
  error: message,
});

export const patientNotifyPreferenceLoaded = (patientNotifyPreference) =>
  ({
    type: TYPES.FOLLOWUP_PATIENT_NOTIFY_PREFERENCE_LOADED,
    patientNotifyPreference,
  });
